import { Component, OnInit, ViewChild } from '@angular/core';
import { UserProductConfigModel } from 'app/data/models/master/op';
import { ProductInvGridConfigModel } from 'app/data/models/master/op/product-inv-grid-config.model';
import { BaseComponent, Constant } from 'app/infrastructure/common';
import { OnlineProductInventoryGridConfigService } from 'app/infrastructure/services/master/op';
import { ProductConfigService, ProductService } from 'app/infrastructure/services/master/wm';
import { OnlineOrderService } from 'app/infrastructure/services/transaction/op/outbound/order';
import { OnlineOrderLineService } from 'app/infrastructure/services/transaction/op/outbound/order/online-order-line.service';
import * as moment from 'moment';
import { DataTable, SelectItem } from 'primeng/primeng';

declare var jQuery: any;

@Component({
  selector: 'app-inventory-product',
  templateUrl: './inventory-product.component.html',
  styles : [`
    @media only screen and (min-width: 320px) and (max-width: 480px) {

        .data-table-container {
            max-width: 480px;
        }
    }

    @media only screen and (min-width: 481px) and (max-width: 640px) {

        .data-table-container {
            max-width: 640px;
        }
    }

    @media only screen and (min-width: 641px) and (max-width: 960px) {

        .data-table-container {
            max-width: 960px;
        }
    }

    @media only screen and (min-width: 961px) and (max-width: 1024px) {

        .data-table-container {
            max-width: 1024px;
        }
    }

    @media only screen and (min-width: 1025px) and (max-width: 1280px) {

        .data-table-container {
            max-width: 1280px;
        }
    }

    @media only screen and (min-width: 1281px) and (max-width: 2100px){

        .data-table-container {
            max-width: 1650px;
        }
    }

    @media only screen and (min-width: 1281px) and (max-width: 1800px){

      .data-table-container {
          max-width: 1650px;
      }
    }

    .data-table-container {
    position: relative;
    }

    .loading-overlay {
      opacity : 0.8;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      // background: var(--ifl-form-bg-lighter-color);
      background : #f3f3f4;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
      margin-right: 32px !important;
      margin-left: 32px !important;
    }

    .spinner {
      border: 4px solid rgba(0, 0, 0, 0.1);
      border-left-color: inherit;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
`],
})
export class InventoryProductComponent extends BaseComponent implements OnInit {
  @ViewChild('dt') dataTable!: DataTable;

  constructor(private onlineOrderLineService: OnlineOrderLineService,
    private productConfigService: ProductConfigService,
    private productService: ProductService,
    private onlineOrderService: OnlineOrderService,
    private onlineProductInventoryGridConfigService: OnlineProductInventoryGridConfigService
  ) {
    super();
  }

  //accounts: any[];
  accounts: SelectItem[] = [];
  filterVariableList: any[];
  availableProducts: any[];
  isLoading: boolean = false;
	totalOrderRecords = 0;
  prodInvGrid: UserProductConfigModel = new UserProductConfigModel();
  searchParams: any = {};
  isLoadingAccounts: boolean = false;
  isLoadingProdGridInv: boolean = false;
  productInvGridConfig: ProductInvGridConfigModel = new ProductInvGridConfigModel();
  defaultOwnerProdInvGridCfg: string = '%';

  filterVariables = {
    CustomerProductCodeActive: { key: 'CustomerProductCode', value: 'Customer Product Code' },
    CustomerProductDescriptionActive: { key: 'CustomerProductDescription', value: 'Customer Product Description' },
    VintageActive: { key: 'Vintage', value: 'Vintage' },
    FormatActive: { key: 'Format', value: 'Litreage' },
    AlcoholStrengthActive: { key: 'AlcoholStrength', value: 'Alcohol Strength' },
    DutyStatusActive: { key: 'DutyStatus', value: 'Duty Status' },
    AvailQtyActive: { key: 'AvailQty', value: 'Avail Qty' },
    UomActive: { key: 'Uom', value: 'UOM' },
    CasingQuantityActive: { key: 'CasingQuantity', value: 'Casing Quantity' },
    CasingTypeActive: { key: 'CasingType', value: 'Casing Type' },
    ConditionActive: { key: 'Condition', value: 'Condition' },
    CountryActive: { key: 'Country', value: 'Country' },
    LotsActive: { key: 'Lots', value: 'Lots' },
    LwinActive: { key: 'Lwin', value: 'LWIN' },
    DescriptionActive: { key: 'Description', value: 'Description' },
    ProductTypeActive: { key: 'ProductType', value: 'Product Type' },
    ProductSubTypeActive: { key: 'productProductSubType_sub_type', value: 'Product Sub Type' },
    ColourActive: { key: 'Colour', value: 'Colour' },
    RegionActive: { key: 'Region', value: 'Region' },
    SubRegionActive: { key: 'SubRegion', value: 'Sub-Region' },
    ProducerActive: { key: 'Producer', value: 'Producer' },
    ClassificationActive: { key: 'Classification', value: 'Classification' },
    PriceActive: { key: 'Price', value: 'CIF' },
    CurrencyActive: { key: 'Currency', value: 'Currency' },
    ExpiryDateActive: { key: 'ExpiryDate', value: 'Expiry Date' },
    RemarksActive: { key: 'Remarks', value: 'Remarks' },
    GrnNoActive: { key: 'GrnNo', value: 'Grn No' },
    GrnDateActive: { key: 'GrnDateString', value: 'Grn Date' },
    StorageCategoryActive: { key: 'StorageCategory', value: 'Storage Category' },
  };

  selectedItem: any;
  fieldName = 'name';
  filteredItems: any[];

  filters : any[] = [];
  filterVariable: any = null;
  filterSelected: string = '';
  tmpFilterSelected: any = null;

  ngOnInit() {
    this.loadAccounts();
  }

  loadAccounts(): void {
    let self = this;
    this.isLoadingAccounts = true;

    var groupId = this.token.GroupId;
    this.onlineOrderService.getAuthOwnerCustomerReprecentatives(groupId)
        .subscribe(
        data => {
            self.isLoadingAccounts = false;

            let message = data;
            if (message && message.MessageType && message.MessageType.Value) {
                if (message.MessageType.Value == Constant.MessageType.success) {
                    // self.accounts = message.Result;
                    message.Result.forEach(obj => {
                      self.accounts.push({label:obj.OwnerName, value:obj});
                    });

                    const defaultOwnerCode = this.accounts.filter(f => f.value.OwnerCode === this.token.DefaultOwnerCode);
                    
                    this.filters.push({
                      filterField : 'OwnerCode',
                      filterValue : defaultOwnerCode[0].value.OwnerCode,
                      filterLabel: 'Owner',
                      filterDisplayValue: defaultOwnerCode[0].value.OwnerName
                    });
                    const ownerCodeFilters = this.filters.filter(f => f.filterField === 'OwnerCode');
                    const selectedOwnerCode: any = ownerCodeFilters[0]['filterValue'];
                    self.loadprodInvGrid(selectedOwnerCode);
                }
                else {
                    self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                }
            }
            else {
                self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
            }
        },
        error => {
            self.isLoadingAccounts = false;
            self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        }
        );
}

onRemoveTag(event: any) {
  this.filters = this.filters.filter(f => f.filterField !== event);
  this.loadProducts(null);
}

preview() {
  let self = this;
  let foundOwner : any = null;

  if (this.filterVariable && this.filterSelected) {
    const index = this.filters.findIndex(f => f.filterField === this.filterVariable);

    if(this.filterVariable == 'OwnerCode'){      
      console.log('OwnerCode');
      console.log(this.filterSelected);
      this.tmpFilterSelected = this.filterSelected;
      this.filterSelected = this.tmpFilterSelected.OwnerCode;
      foundOwner = this.accounts.find(item => item.value.OwnerCode === this.filterSelected);
    }      

    const result = {
      filterField : this.filterVariable,
      filterValue : this.filterSelected,
      filterLabel : this.filterVariableList.find(option => option.key === this.filterVariable).value,
      filterDisplayValue : (this.filterVariable == 'OwnerCode' ? (foundOwner ? foundOwner.label : 'Owner not found') : '')
    };

    if (index !== -1) {
      this.filters[index] = result;
    } else {
      this.filters.push(result);
    }
  }

  this.filterVariable = null
  this.filterSelected = ''

  this.searchParams.SessionId = this.token.SessionId;
  this.searchParams.ReportName = 'Inventory Movement Detail Report';
  this.searchParams.DateFormat = this.token.DateFormatDescription;

  //.log(this.filters);


  this.loadProducts(null);
}

  loadProducts($event): void {
    var self = this;


    self.isLoading = true;
    const ownerCodeFilters = this.filters.filter(f => f.filterField === 'OwnerCode');
    const selectedOwnerCode: any = ownerCodeFilters[0] ? ownerCodeFilters[0]['filterValue'] : this.token.DefaultOwnerCode;
    var ownerCode = selectedOwnerCode;
    var warehouseCode = self.token.DefaultWarehouseCode;
    var orderType = "Local";
    var deliveryDateString = moment(new Date()).format(self.token.DateFormatDescription.toUpperCase());

    var queryRequest = {
			filters: null,
			pageNumber: 1,
			pageSize: 10,
			sortField: null,
			sortDirection: null
		};

    const transformedFilters = this.filters
    .filter(f => f.filterField !== 'OwnerCode')
    .map(function(f) {
      if(f.filterField.toLowerCase() == 'dutystatus') {
        return {
          propertyName: f.filterField,
          operation: 'equals',
          value: f.filterValue
        }

      } else {
        return {
          propertyName: f.filterField,
          operation: 'contains',
          value: f.filterValue
        }
      }

    });

    queryRequest.filters = transformedFilters;

		if ($event != null){
			queryRequest.pageNumber = ($event.first / $event.rows) + 1;
			queryRequest.pageSize = $event.rows;
			queryRequest.sortField = $event.sortField;
			queryRequest.sortDirection = $event.sortOrder;
		}

    this.onlineOrderLineService.getAvailableInvPackDetailsProdInv(ownerCode, warehouseCode, orderType, deliveryDateString, queryRequest)
      .subscribe(
      data => {
        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value == Constant.MessageType.success) {

            self.availableProducts = message.Result;
						self.totalOrderRecords = message.Count;

          }
          else {
            self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }

          self.isLoading = false;
        }
        else {
          self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
          self.isLoading = false;
        }
      },
      error => {
        self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
      }
      );
  }

  loadFilterVariables() {
    this.filterVariableList = [];
    this.filterVariableList.push({ key: 'OwnerCode', value: 'Owner' });
    // this.filterVariable = 'OwnerCode';

    Object.keys(this.productInvGridConfig).forEach((key) => {
      if (typeof this.productInvGridConfig[key] === 'boolean' && this.productInvGridConfig[key] === true) {
        const filterData = this.filterVariables[key];
        if (filterData) {
          this.filterVariableList.push({ key: filterData.key, value: filterData.value });
        }
      }
    });
  }

  variableTypeChange(){
    this.filterSelected = '';
  }

  inputType(variable: any): string {
    if(variable){
      if (variable === 'OwnerCode') {
        return 'dropdown';
      } else if (variable === 'CustomerProductCode' || variable === 'CustomerProductDescription') {
        return 'autocomplete';
      } else if (variable === 'DutyStatus') {
        return 'dropdown-duty-status';
      } else {
        return 'textbox';
      }
    } else {
      return 'textbox';
    }
  }

  loadprodInvGrid(ownerCode: string): void {
    let self = this;

    ownerCode = self.defaultOwnerProdInvGridCfg;

    self.productConfigService.getProductInventoryGridConfig(ownerCode)
      .subscribe(
      data => {
        self.isLoadingProdGridInv = false;

        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value == Constant.MessageType.success) {
            self.prodInvGrid = message.Result;
            self.productInvGridConfig = message.Result;
            this.loadFilterVariables();
          }
          else {
            self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }
        }
        else {
          self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        }
      },
      error => {
        self.isLoadingProdGridInv = false;
        self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
      }
      )
  }

  save(model: ProductInvGridConfigModel) {
    let self = this;

    if (!model.CreatedBy) {
      model.CreatedBy = self.token.UserId;
    }
    model.UpdatedBy = self.token.UserId;

    //console.log(model)

    self.onlineProductInventoryGridConfigService.save(model)
        .subscribe(
            data => {
                self.isLoading = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    this.loadProducts(null);
                    const ownerCodeFilters = this.filters.filter(f => f.filterField === 'OwnerCode');
                    const selectedOwnerCode: any = ownerCodeFilters[0]['filterValue'];
                    this.loadprodInvGrid(selectedOwnerCode);
                }
                else {
                    self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoading = false;
                self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            });
}

  onFilter(event: any) {
    //console.log(event);
    if (event.originalEvent instanceof FocusEvent) {
      this.getFilterItems('');
    } else {
      let query = event.query.toLowerCase();
      this.getFilterItems(query);
    }
  }

  getFilterItems(params : any){
    this.filteredItems = [];
    const ownerCodeFilters = this.filters.filter(f => f.filterField === 'OwnerCode');
    const selectedOwnerCode: any = ownerCodeFilters[0]['filterValue'];
    if(this.filterVariable !== ''){
      const filterType = this.filterVariable;

      if(filterType == 'CustomerProductCode'){
        this.fieldName = 'ProductCode'
        this.isLoadingAccounts = true;
        this.productService.getProductCode(params, selectedOwnerCode)
        .subscribe(data => {
          let message = data;
          if (message && message.MessageType && message.MessageType.Value) {
              if (message.MessageType.Value == Constant.MessageType.success) {
                if(message.Result.length > 0){
                  this.filteredItems = []
                  for(let data of message.Result){
                    this.filteredItems.push(data['ProductCode']);
                  }
                } else {
                  this.filteredItems = [];
                }
              }
              else {
                  this.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
              }
          }
          else {
          }
          this.isLoadingAccounts = false;
        })
      } else if (filterType == 'CustomerProductDescription'){
        this.fieldName = 'ProductName'
        this.isLoadingAccounts = true;
        this.productService.getProductDescription(params, selectedOwnerCode)
        .subscribe(data => {
          let message = data;
          if (message && message.MessageType && message.MessageType.Value) {
              if (message.MessageType.Value == Constant.MessageType.success) {
                if(message.Result.length > 0){
                  this.filteredItems = []
                  for(let data of message.Result){
                    this.filteredItems.push(data['ProductName']);
                  }
                } else {
                  this.filteredItems = [];
                }
              }
              else {
                  this.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
              }
          }
          else {
          }
          this.isLoadingAccounts = false;
        })
      }
    }
  }

  openPopup(){
    const ownerCodeFilters = this.filters.filter(f => f.filterField === 'OwnerCode');
    const selectedOwnerCode: any = ownerCodeFilters[0]['filterValue'];
    this.loadprodInvGrid(selectedOwnerCode);
  }

  isHidden(isVisible: boolean): boolean {
    return (isVisible != true);
  }

  truncateString(str, num) {
    if(str!=null){
      return str.length > num ? str.slice(0, num) + '...' : str;
    } else {
      return ''
    }
  }

  showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
    let truncatedAdditionalInfo = this.truncateString(additionalInfo, 1000);
    jQuery('#PopupMessageTitle').html(title);
    jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (truncatedAdditionalInfo ? ' -- ' + truncatedAdditionalInfo : ''));
    jQuery('#PopupMessage').modal('show');
  }

  showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
    alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''))
  }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/reports/inventory-product/inventory-product.component.ts